export default __webpack_public_path__ + "static/floatingImg7-f934e14aa5d7f741ab5c22b7f504d664.webp";